/**
 * event
 * 处理和事件相关的内容，所有元素上真实的事件绑定只会出现一份
 *
 * Created by Samuel on 2022/5/9
 */
import * as _ from 'lodash-es';

class EventHandler {
	constructor(target) {
		this.target = target;
		this.listeners = {};
		this.eventListeners = {};
	}

	// 使用 dispatch 模式进行事件绑定
	addEvent(eventName, listener, options = { capture: false }) {
		const _tag = `${eventName}_${JSON.stringify(options)}`;
		if (!this.listeners[_tag]) {
			this.listeners[_tag] = [];
			this.eventListeners[_tag] = (...args) => {
				if (this.listeners[_tag]) {
					_.forEach(this.listeners[_tag].slice(), (listener) => listener?.(...args));
				}
			};
			this.target.addEventListener(eventName, this.eventListeners[_tag], options);
		}
		if (listener && this.listeners[_tag].indexOf(listener) === -1) {
			this.listeners[_tag].push(listener);
		}
		let isSubscribed = true;

		return () => {
			// -->
			if (!isSubscribed) {
				return;
			}
			isSubscribed = false;
			let _idx = this.listeners[_tag] ? this.listeners[_tag].indexOf(listener) : -1;
			if (_idx > -1) {
				this.listeners[_tag].splice(_idx, 1);
			}
			if (_.isEmpty(this.listeners[_tag])) {
				// clean & unbind
				this.target.removeEventListener(eventName, this.eventListeners[_tag], options);
				delete this.listeners[_tag];
			}
		};
	}
}

const targetMap = new WeakMap();
export const addEventListener = (target, eventName, listener, options) => {
	if (!targetMap.has(target)) {
		targetMap.set(target, new EventHandler(target));
	}
	return targetMap.get(target).addEvent(eventName, listener, options);
};
